export default "__VITE_ASSET__DtMk0mxd__"